import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
} from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';

import {
  ButtonModule,
  ControlType,
  DialogRef,
  IconModule,
  SimpleInputModule,
} from '@hglobal/fin-ui';
import { FormBuilder } from '@ngneat/reactive-forms';
import { TranslateModule } from '@ngx-translate/core';

import { LogoComponent } from '@iw/common';
import { AuthStore } from '@iw/core/auth-store';

import { SigninDialog } from '../signin.dialog';
import { TfaResetComponent } from '../tfa-reset/tfa-reset.component';

@Component({
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
    IconModule,
    SimpleInputModule,
    LogoComponent,
  ],
  selector: 'iw-tfa',
  templateUrl: './tfa.component.html',
  styleUrls: ['./tfa.component.scss', '../signin-dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TfaComponent {
  readonly #fb = inject(FormBuilder);
  readonly #store = inject(AuthStore);
  readonly #dialogRef = inject(DialogRef);
  readonly #dialog = inject(SigninDialog);

  controlType = ControlType;

  isLoading = false;

  form = this.#fb.group({
    code: ['', Validators.required],
  });
  errorDictionary: Record<string, string> = {
    apiValidation: 'errors.invalid_two_factor_code',
  };

  readonly verifyCodeSuccessEffect = effect(() => {
    const verified = this.#store.isVerifyCodeSuccess();
    if (verified) {
      this.isLoading = false;
      this.#dialogRef.close();
      this.#store.resetRequestStatus('verifyCode');
    }
  });

  readonly verifyCodeFailedEffect = effect(() => {
    const error = this.#store.verifyCodeError();
    if (error) {
      this.isLoading = false;
      error?.code === 'invalid_two_factor_code' &&
        this.form.controls.code.setErrors({ apiValidation: true });
    }
  });

  verify(): void {
    this.isLoading = true;
    this.#store.verifyCode({ ...this.form.value });
  }

  openResetDialog(): void {
    this.#dialogRef.close();
    this.#dialog.open(TfaResetComponent);
  }
}
